<template>
    <section class="recent-wrapper wallet-recent-wrapper">
        <div class="container">
            <div class="thm-heading wallet-deposit-heading">
                <div class="go-back-btn">
                    <span class="Withdraw-link">
                        <a class="go_back_btn12" @click="$router.go(-1)">
                        <i class="fa-solid fa-angle-left text-white"></i>
                        <!-- {{ $t('back', 'Back') }} -->
                        <h3>{{ $t('deposit', 'Deposit') }}</h3>
                    </a>
                    </span>
                </div>
                <div class="go-back-btn">
                    <div class="min_max_value">
                        <label>
                            <span>{{$t('min','Min')}}: </span>
                           {{ minAmount }}
                        </label>
                        <label class="ps-1">
                            <span>{{$t('max','Max')}}: </span> 
                           {{ maxAmount }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="awaiting-bonus-sec deposit_page_sec">
        <div class="deposit_page_div">
            <div class="container-fluid">
                <div class="pending-bonus-transfer-sec">
                    <div class="deposit-withdraw-sec">
                        <div class="dw_bg_cl">
                            <div class="depo-rgt-container amount_container_cl">
                                <div class="amount_input_cl">
                                    <!-- <label for="amount1">{{ $t('amount', 'Amount') }}</label> -->
                                    <div class="amount_input_btn_cl">
                                        <input type="tel" :placeholder="$t('enter-amt', 'Enter Deposit Amount')" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.deposit_range?.max || 99999999)" v-model="amount" class="form-control">
                                    </div>
                                </div>
                                <div class="deposit-amount-bx" v-if="walletData">
                                    <ul>
                                        <template  v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes] : walletConfig?.stake_button)" :key="index">
                                        <li @click="setAmount(stake)">
                                            <span class="btn-thm" >{{ stake }}</span></li>
                                        </template>
                                    </ul>
                                </div>
                                <div class="withdraw-btn deposit-module">
                                    <a href="#singlestakeeditModal"  data-bs-toggle="modal" class="thm-but edit_stake_btn12">
                                        <span><i class="fa-regular fa-pen-to-square"></i></span> 
                                        {{ $t('edit-stake', 'Edit Stake') }}
                                    </a>
                                    <button type="button" :class="{'btn-disabled' : amount < walletConfig?.deposit_range?.min }"
                                        @click="callForDepositMethods()" class="input-group-text amountBtn submit_stake_btn12">
                                        {{ $t('submit', 'SUBMIT') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TutorialVideo type = "2"/>
    </section>
    <div class="modal fade" id="language-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="langmodal">
        <LanguageModal></LanguageModal>
    </div>
    <WalletStakeModal ref="resetStakeCall" v-if="walletData" :stakes="walletData" />
</template>

<script>
import { defineAsyncComponent } from 'vue';
import {  setWalletStakeValue } from '../services/module';
import { mapGetters } from 'vuex';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletStakeModal from '../components/StakeModal.vue';
export default {
    name: 'WalletDeposit',
    inject: ['walletConfig'],
    data() {
        return {
            walletData: null,
            loading: false,
            amount: null
        }
    },
    components:{
        WalletStakeModal,
        TutorialVideo,
    },
    computed: {
        minAmount() {
            return this.walletConfig?.deposit_range?.min ?? 100;
        },
        maxAmount() {
            return this.walletConfig?.deposit_range?.max ?? 99999999;
        },
        ...mapGetters(['userTransactionStakes', 'globalLoader'])
    },
    mounted() {
         this.getStakes();
    },
    methods: {
         callForDepositMethods() {
            if (this.amount == null || 
            this.amount < (!this.walletConfig?.deposit_range?.min ? 100 : this.walletConfig?.deposit_range?.min) || 
            this.amount > (!this.walletConfig?.deposit_range?.max ? 99999999 : this.walletConfig?.deposit_range?.max)) {
                const minAmount = !this.walletConfig?.deposit_range?.min ? 100 : this.walletConfig?.deposit_range?.min;
                const maxAmount = !this.walletConfig?.deposit_range?.max ? 99999999 : this.walletConfig?.deposit_range?.max;
                this.$errorToast(`${this.$t('please-enter-an-amount-between', 'Please enter an amount between')} ${minAmount} and ${maxAmount}.`);
            } else {
                this.goToDepositMethods();
            }

        },
        getStakes() {
            this.walletData = this.walletConfig?.stake_button;
            if(!this.walletData) {
                this.initializeStake();
            } 
        },
        initializeStake(){
                this.walletData.stake = {
                    stake1 : 100,
                    stake2 : 500,
                    stake3 : 1000,
                    stake4 : 2000,
                };
        },
        setAmount(stake){
            try {
                const response =  setWalletStakeValue(stake, this.amount, this.walletConfig)
                if(response){
                    this.amount =  response; 
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        goToDepositMethods() {
            this.$store.dispatch('setDepositAmount', this.amount);
            this.$router.push({ name: 'deposit-payment-method' })
        }
    }
}
</script>

<style scoped>
    .deposit-amount-bx {
    margin-top: 10px;
}
</style>